import Grid2 from '@mui/material/Unstable_Grid2'; // Grid ver
import { useTranslation } from 'react-i18next';
import { useRestaurantData } from '../../provider/RestaurantDataContext';
import CustomTitleBox from '../centralComponents/CustomTitleBox';
import OpeningDay from './OpeningDay';

export default function OpeningHoursPage() {
    const { t } = useTranslation();
    const { restaurantData: { openingDays } } = useRestaurantData();

    return (
        <CustomTitleBox title={t('openingHours')}>
            <Grid2 container direction="row" spacing={2.5} columns={16} style={{ fontSize: '1.2rem' }}>
                {
                    openingDays.map((openingDay) => ([
                        <OpeningDay key={openingDay.id} openingDay={openingDay} />
                    ]))
                }
            </Grid2>
        </CustomTitleBox>
    );
}